
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vitrins",
      function () {
        return require("private-next-pages/vitrins/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vitrins"])
      });
    }
  